import React from 'react';
import PropTypes from 'prop-types';
import ruLocale from "date-fns/locale/ru";
import DateFnsUtils from "@date-io/date-fns";
import {makeStyles} from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';

import {Grid, withStyles} from "@material-ui/core";

import Button from "@material-ui/core/Button";

import {DatePicker} from "@material-ui/pickers";
import Select from "./Select";
import Pagination from "@material-ui/lab/Pagination";
import createMuiTheme from "@material-ui/core/styles/createMuiTheme";
import {ThemeProvider} from "@material-ui/styles";

import MuiPickersUtilsProvider from "@material-ui/pickers/MuiPickersUtilsProvider";
import {useDispatch, useSelector} from "react-redux";
import {useHistory, useLocation} from "react-router-dom";
import {getPayments} from "../services/authService";
import {parseFiltersFromSearch, syncFiltersToUrl} from "../utils/urlFilters";

const PAYMENTS_FILTERS_SCHEMA = {page: 'number', rowsPerPage: 'pageSize', dateFrom: 'date', dateTo: 'date'};

const headCells = [
    {id: 'transactionId', numeric: true, disablePadding: false, label: 'ID Транзакции'},
    {id: 'paymentDate', numeric: true, disablePadding: false, label: 'Дата пополнения'},
    {id: 'price', numeric: true, disablePadding: false, label: 'Сумма пополнения'},
];

function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function getComparator(order, orderBy) {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
}


function EnhancedTableHead(props) {
    const {classes, order, orderBy, onRequestSort} = props;
    const createSortHandler = (property) => (event) => {
        onRequestSort(event, property);
    };

    return (
        <TableHead>
            <TableRow>
                {headCells.map((headCell) => (
                    <TableCell
                        key={headCell.id}
                        align={'left'}
                        padding={headCell.disablePadding ? 'none' : 'default'}
                        sortDirection={orderBy === headCell.id ? order : false}
                    >

                        {headCell.label}

                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    );
}

EnhancedTableHead.propTypes = {
    classes: PropTypes.object.isRequired,
};

const Theme = createMuiTheme({
    overrides: {
        MuiOutlinedInput: {
            root: {
                borderRadius: '20px 20px',
            },
            input: {
                padding: '10.5px 14px',
            }
        },
        MuiFormLabel: {
            root: {
                lineHeight: 0
            }
        }
    },
    palette: {
        primary: {
            main: '#95c61c'
        },

        secondary: {
            main: '#95c61c',
            light: '#b2d164'
        },
    },
});

const StyledTableRow = withStyles((theme) => ({
    root: {
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.action.hover,
        },
    },
}))(TableRow);

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',

    },
    typography: {},
    paper: {
        width: '100%',
        marginBottom: theme.spacing(2),
    },
    table: {},
    visuallyHidden: {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        top: 20,
        width: 1,
    },
    selectedRow: {
        '&:hover': {
            backgroundColor: theme.palette.action.hover
        }
    },
    selectedPagin: {
        color: '#ffffff'
    },
    '@global': {
        '.MuiPaginationItem-textPrimary.Mui-selected': {
            color: '#ffffff'
        }
    }
}));

export default function TablePayment(props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const history = useHistory();
    const location = useLocation();
    const pagination = useSelector(state => state.Auth.paymentsPagination) || {};

    const initialFilters = React.useMemo(
        () => parseFiltersFromSearch(location.search, PAYMENTS_FILTERS_SCHEMA),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        []
    );
    const [page, setPage] = React.useState(initialFilters.page || 1);
    const [rowsPerPage, setRowsPerPage] = React.useState(initialFilters.rowsPerPage || 10);
    const [startDate, setStartDate] = React.useState(initialFilters.dateFrom || null);
    const [endDate, setEndDate] = React.useState(initialFilters.dateTo || null);

    React.useEffect(() => {
        dispatch(getPayments({
            page,
            rowPerPage: rowsPerPage,
            dateFrom: startDate ? startDate.toISOString() : undefined,
            dateTo: endDate ? endDate.toISOString() : undefined,
        }));
        syncFiltersToUrl(history, {page, rowsPerPage, dateFrom: startDate, dateTo: endDate});
    }, [dispatch, history, page, rowsPerPage, startDate, endDate]);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        event = event === 'ВСЕ' ? event : parseInt(event, 10);
        setRowsPerPage(event);
        setPage(1);
    };

    const handleChangeStartDate = (value) => {
        setStartDate(value);
        setPage(1);
    };

    const handleChangeEndDate = (value) => {
        setEndDate(value);
        setPage(1);
    };

    return (
        <div className={classes.root}>
            <Grid container alignItems={'stretch'} direction={'row'} justify={'wrap'}>
                <Grid item xs={3} lg={3} md={3} sm={3}>
                    <Typography
                        component={'div'}
                        style={{marginBottom: '30px', fontSize: '2rem'}}
                    >
                        История платежей
                    </Typography>
                </Grid>
                <Grid item xs={1.5} lg={1.5} md={1.5} sm={1.5}>

                </Grid>
                <Grid item xs={1.5} lg={1.5} md={1.5} sm={1.5}>
                    <ThemeProvider theme={Theme}>
                        <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ruLocale}>
                            <DatePicker
                                disableToolbar
                                variant="inline"
                                inputVariant={'outlined'}
                                label="Дата с:"
                                value={startDate}
                                onChange={handleChangeStartDate}
                                maxDate={endDate}
                            />
                        </MuiPickersUtilsProvider>
                    </ThemeProvider>
                </Grid>
                <Grid item xs={1} lg={1} md={1} sm={1}></Grid>
                <Grid item xs={1.5} lg={1.5} md={1.5} sm={1.5}>
                    <ThemeProvider theme={Theme}>
                        <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ruLocale}>
                            <DatePicker
                                disableToolbar
                                variant="inline"
                                inputVariant={'outlined'}
                                label="Дата по:"
                                value={endDate}
                                onChange={handleChangeEndDate}
                                minDate={startDate}
                                maxDate={new Date()}
                            />
                        </MuiPickersUtilsProvider>
                    </ThemeProvider>
                </Grid>
                <Grid item xs={1.5} lg={1.5} md={1.5} sm={1.5}>

                </Grid>
                {/*<Grid item xs={3} lg={3} md={1.5} sm={3} justify={'wrap'}>*/}
                {/*    <Button variant="contained" color="primary" style={{borderRadius: '50px',marginLeft:'15px',   fontSize: '1rem', color: '#fff'}}>*/}
                {/*        Пополнить*/}
                {/*    </Button>*/}
                {/*</Grid>*/}
            </Grid>
            <Paper component={'div'} className={classes.paper}>


                <TableContainer>
                    <Table
                        className={classes.table}
                        aria-labelledby="tableTitle"
                        size={'medium'}
                        aria-label="enhanced table"
                    >
                        <EnhancedTableHead
                            classes={classes}
                            rowCount={props.data.length}
                        />

                        <TableBody>
                            {props.data
                                .map((row, index) => {

                                    const labelId = `enhanced-table-checkbox-${index}`;

                                    return (

                                        <StyledTableRow
                                        >
                                            <TableCell component="th" id={labelId} scope="row">
                                                {row.token}
                                            </TableCell>
                                            <TableCell align="left">{new Date(row.created).toLocaleString()}</TableCell>
                                            <TableCell align="left">{row.cost / 100}</TableCell>

                                        </StyledTableRow>
                                    );
                                })}

                        </TableBody>

                    </Table>
                </TableContainer>


            </Paper>
            <Grid container>
                <Grid item xs={0} sm={0} md={6} lg={8}></Grid>
                <Grid item xs={12} sm={12} md={6} lg={4} style={{
                    display: 'flex',
                    aligItems: 'center',
                    fontSize: '11px',
                    alignItems: 'center',
                    color: 'gray'
                }}>
                    <Typography variant={'span'} style={{'marginRight': '10px'}}>
                        Записей на странице
                    </Typography>
                    <Select
                        value={rowsPerPage}
                        type={'select'}
                        rowsPerPageOptions={[10, 25, 50, 100, 'ВСЕ']}
                        borderRadius={'20px 20px'}
                        width={'67px'}
                        onChange={handleChangeRowsPerPage}
                    />

                    {rowsPerPage !== 'ВСЕ' && <Pagination
                        classes={{selected: classes.selectedPagin}}
                        count={pagination.lastPage || 1}
                        page={page}
                        color="primary"
                        onChange={handleChangePage}
                        size={'large'}/> }
                </Grid>
            </Grid>
        </div>
    );
}
